
const SHAREABLE_LINKS = {
  facebook: 'https://www.facebook.com/sharer.php?u=',
  linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  twitter: 'https://twitter.com/share?url=',
}
const MODAL_HEIGHT = 500
const MODAL_WIDTH = 400
export default {
  name: 'SocialIcons',
  props: {
    iconStyles: {
      type: String,
      default: 'px-1 text-black cursor-pointer hover:text-blue-800 w-7 h-7',
    },
    containerStyles: {
      type: String,
      default: 'flex items-center justify-end space-x-1',
    },
  },
  methods: {
    sharePage(type = 'facebook') {
      const isIos =
        [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod',
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)

      const sharableUri = SHAREABLE_LINKS[type] + window?.location?.href

      if (isIos) {
        window.location.href = sharableUri
        return
      }
      const params = `"menubar=no,toolbar=no,resizable=no,status=no,width=${MODAL_HEIGHT},height=${400},top=${
        window.innerHeight / 2 - MODAL_HEIGHT / 2
      },left=${window.innerWidth / 2 - MODAL_WIDTH / 2}`

      window?.open(sharableUri, 'Social Share', params).focus()
    },
  },
}
